const initScrollReveal = () => {
	ScrollReveal().reveal(
		'.partner-map__content, .youtube-widget, .magazine-widget, .pinterest-widget',
		{
			duration: 1200,
			viewFactor: 0.2,
			origin: 'bottom',
			distance: '60px',
			easing: 'ease-out',
		}
	);
};

document.defaultView.addEventListener( 'DOMContentLoaded', initScrollReveal );
